export default {
  "content": "<path d=\"M11.813 6.081L7.943 11.5H11v2H7v2h4v2H7v3H5v-3H1v-2h4v-2H1v-2h3.058L.187 6.081 1.813 4.92 6 10.779l4.187-5.86 1.627 1.162zM23.207 11.793a1 1 0 01.066 1.34l-.066.074-4.5 4.5-1.414-1.414 2.793-2.793H13v-2h7.086l-2.793-2.793 1.414-1.414 4.5 4.5z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};